import { gql } from '@apollo/client';

export const SEARCH_EV_CONNECTORS = gql`
  query searchEvConnectors($publicDisplayId: String!) {
    searchEvConnectors(publicDisplayId: $publicDisplayId) {
      parkingZoneUid
      power
      publicDisplayId
      socketStatus
      type
      parkZone {
        uid
        commercialZoneView {
          name
        }
        countryCode
      }
    }
  }
`;
